import React, { useState, useEffect, useRef } from 'react';
import { 
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Label,
  CustomInput,
  Collapse,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';

import { connect } from 'react-redux';
import { addDivision } from '../../flux/actions/divisionActions';
import { getDivisionSamples, clearDivisionSamples } from '../../flux/actions/divisionsampleActions';
import { getDivisionPartitionTypes, clearDivisionPartitionTypes } from '../../flux/actions/divisionpartitiontypeActions';
import { IDivisionModal, IDivisionModalReduxProps, ITarget } from '../../types/interfaces';
import Select from 'react-select';
import LoadingPage from '../../pages/loading';
import Loading from '../Loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faBuilding, faHashtag, faHouseDamage, faLayerGroup, faMoneyBill, faMoneyBillAlt, faRulerCombined, faThLarge, faCompass, faMap, faQuestionCircle, faSquare, faCheckSquare, faSearch, faBookmark, faMapMarkerAlt, faSignature, faFolder, faFileInvoice, faReceipt, faFileContract, faFilePdf, faSync, faCloudUploadAlt, faHandRock, faTimes, faSpinner, faCheckCircle, faInfoCircle, faPercent, faPen, faCalendarAlt, faFileImage, faBookOpen, faPrint, faFileDownload, faPencilRuler, faLockOpen, faCommentsDollar, faSyncAlt, faPlus, faAngleDoubleDown, faAngleDown, faEdit } from '@fortawesome/free-solid-svg-icons'
import { useHistory, useLocation } from 'react-router-dom';
import { useAlert } from "react-alert";
import ReactTooltip from 'react-tooltip';
import moment from "moment";
import { PRIVILEGE } from '../../types/privileges'
import NumberFormat from 'react-number-format';
import PDFLink, { PreviewBase64, printBase64, downloadBase64, instantUploadToFTP, printBuffer } from '../pdf/PDFLink';

import DatePicker from "reactstrap-date-picker";
import Association from './Association';
import AssociationFields from '../vente/bien/VAssociationFields';

const DivisionModal = ({ 
  modal,
  setModal,
  bien,
  isMultipleBiens,
  biens,
  addDivision,
  addCallback,
  getDivisionSamples,
  clearDivisionSamples,
  division_sample,
  getDivisionPartitionTypes,
  clearDivisionPartitionTypes,
  division_partition_type,
  auth
 }: IDivisionModal) => {
  const alert = useAlert();
  const history = useHistory();

  const {division_partition_types, loading: loadingT} = division_partition_type
  const {division_samples, loading: loadingS} = division_sample
  
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const [floorValue, setFloorValue] = useState<any>('');
  const [totalPriceValue, setTotalPriceValue] = useState(0);
  const totalPriceRef = useRef<HTMLInputElement>(document.createElement("input"));
  const [totalPriceFlag, setTotalPriceFlag] = useState(false);
  const partitionTypeOptions = division_partition_types.map(e => ({value: e, label: e.name}))
  const [partitionTypesValue, setPartitionTypesValue] = useState<any[]>([]);
  const [floors, setFloors] = useState<any[]>([]);
  const [floorIndexCounter, setFloorIndexCounter] = useState(0);

  const [attributeFloorExpanded, setAttributeFloorExpanded] = useState(false);
  const [loadSampleExpanded, setLoadSampleExpanded] = useState(false);
  
  const [selectedFloor, setSelectedFloor] = useState<any>();
  const [selectedDivisionType, setSelectedDivisionType] = useState<any>();
  const [selectedDivisionPercent, setSelectedDivisionPercent] = useState<any>();
  const [etageValue, setEtageValue] = useState<any>('');
  const [typeValue, setTypeValue] = useState<any>('');
  const [positionValue, setPositionValue] = useState('');
  const [percentValue, setPercentValue] = useState(0);
  const [superficieValue, setSuperficieValue] = useState(0);
  const [prixpartValue, setPrixpartValue] = useState(0);
  const [partCommentValue, setPartCommentValue] = useState('');
  const [association, setAssociation] = useState<any>(undefined);
  
  const divisionsampleOptions = division_samples.map(e => ({value: e, label: e.name}))
  const [selectedDivisionSample, setSelectedDivisionSample] = useState<any>('');

  const [saveSample, setSaveSample] = useState(!!isMultipleBiens);
  const [sampleName, setSampleName] = useState('');

  const [etageOptions, setEtageOptions] = useState<any[]>([]);//bien ? banks.map(e => ({value: e, label: e.fullname}));
  useEffect(() => {
    const etageOptionsTemp: any[] = [];
    const etages = isMultipleBiens ? biens?.length ? Number(biens[0]["ETAGE_ASS"]) : undefined : Number(bien?.["ETAGE_ASS"])
    if(etages !== undefined){
      for(let i = 0; i < etages; i++)
        if(!floors.find(e => e.floor === i))
          etageOptionsTemp.push({value: i, label: `${i === 0 ? "RDC" : i} (${100}% disponible)`})
    }
    setEtageOptions(etageOptionsTemp);
  }, [bien, floors, isMultipleBiens, biens])

  const handleEtageChange = data => {
    setFloorValue({value: data.value, label: data.value === 0 ? "RDC" : data.value});
    totalPriceRef?.current?.focus()
  }
  const handlePartitionTypesChange = data => {
    setPartitionTypesValue(data?.length ? data.map(e => e.value) : []);
    totalPriceRef?.current?.focus()
  }
  

  const handleDivisionSampleChange = data => {
    setSelectedDivisionSample(data || '');
  }

  const sampleNameChangeHandler = (e: ITarget) => setSampleName(e.target.value);

  useEffect(() => {
    if(selectedDivisionSample?.value){
      setSaveSample(false)

      const floors: any[] = []
      let currentFloorIndex = 0
      const sampleFloors = selectedDivisionSample.value.division_sample_floors || []
      for(let i in sampleFloors){
        floors.push({index: currentFloorIndex, floor: sampleFloors[i].floor, totalPrice: sampleFloors[i].totalPrice, division_floor_partition_types: sampleFloors[i].division_sample_floor_partition_types, partitionTypes: sampleFloors[i].division_sample_floor_partition_types.map(e => e.divisionPartitionTypeId)})
        currentFloorIndex++
      }
      setFloorIndexCounter(currentFloorIndex)
      setFloors(floors);

      setFloorValue('');
      setTotalPriceValue(0);
    }
  }, [selectedDivisionSample])

  useEffect(() => {
    clearDivisionSamples()
    clearDivisionPartitionTypes()
    const projectId = isMultipleBiens ? biens?.[0]?.IDPROJET : bien?.IDPROJET
    const etages = isMultipleBiens ? biens?.[0]?.ETAGE_ASS : bien?.ETAGE_ASS
    if(projectId){
      if(etages)
        getDivisionSamples(projectId, etages)
      getDivisionPartitionTypes(projectId)
    }
  }, [bien?.IDPROJET, bien?.ETAGE_ASS, isMultipleBiens, biens?.length])

  useEffect(() => {
    if(!totalPriceFlag)
      setTotalPriceFlag(true)
    else if(totalPriceValue === 0 && totalPriceRef?.current)
      totalPriceRef.current.select()
  }, [totalPriceValue]);

  useEffect(() => {
    setAssociation({
      selectedFloor,
      selectedDivisionType,
      selectedDivisionPercent,
      ETAGE: selectedFloor?.floor,
      TYPE: typeValue ? typeValue["isNew"] ? typeValue["name"] : typeValue.value : undefined,
      POSITION: positionValue,
      POURCENTAGE: selectedDivisionPercent?.percent,
      SUPERFICIE: superficieValue,
      PRIX_VENTE: prixpartValue,
      OBSERVATION: partCommentValue,
    })
  }, [selectedFloor, selectedDivisionType, selectedDivisionPercent, typeValue, positionValue, percentValue, superficieValue, prixpartValue]);
  
  const handleToggle = () => setModal(!modal);

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  const modalOpenedHandle = () => {
    setSelectedDivisionSample('')
    setFloors([])

    setFloorValue('');
    setTotalPriceValue(0);
  };

  const modalClosedHandle = () => {
    setFloorValue('');
    setPartitionTypesValue([]);
    setTotalPriceValue(0);
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const addFloorHandle = () => {
    if(!floorValue?.value && floorValue.value !== 0){
      alert.error("Veuillez sélectionner un étage");
      return
    }
    if(!totalPriceValue){
      alert.error("Veuillez saisir un prix");
      return
    }
    if(!partitionTypesValue?.length){
      alert.error("Veuillez sélectionner un type");
      return
    }
    const currentFloorIndex = floorIndexCounter
    const floorData = {index: currentFloorIndex, floor: floorValue.value, totalPrice: totalPriceValue, division_floor_partition_types: partitionTypesValue.map(e => ({division_partition_type: e})), partitionTypes: partitionTypesValue.map(e => e.id)}
    setFloorIndexCounter(e => e + 1)
    setFloors(e => [...e, floorData]);
    
    if(selectedDivisionSample?.value){
      setSelectedDivisionSample('')
      setLoadSampleExpanded(true)
    }
    setFloorValue('');
    // setPartitionTypesValue([]);
    setTotalPriceValue(0);
  }

  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success(`Répartition créée avec succès`, {timeout: 10000});
      if(addCallback)
        addCallback(success)
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const addDivisionHandle = withDoa => {
    const bienT = isMultipleBiens ? biens?.reduce((e, t) => e && Number(t.PRIX_VENTE || 0) > Number(e.PRIX_VENTE || 0) ? t : e, {} as any) : bien
    if(!bienT?.id)
      return
    const totalFloorsPrice = floors.reduce((e, t) => e + Number(t.totalPrice || 0), 0)
    const bienPrice = Number(bienT.PRIX_VENTE || 0)
    if(totalFloorsPrice < bienPrice){
      alert.error(`Prix parts mal répartis: ${totalFloorsPrice.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} / ${bienPrice.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
      return
    }
    if(floors.length < Number(bienT.ETAGE_ASS || 0)){
      alert.error("Veuillez remplir tous les étages");
      return
    }
    if(!isMultipleBiens && withDoa && bienT?.contrat?.TYPE_VENTE === "UNIQUE"){
      if(!association){
        alert.error("Veuillez saisir les informations de l'association");
        setAttributeFloorExpanded(true)
        return
      }
      if(association.ETAGE === undefined){
        alert.error("Veuillez sélectionner un étage");
        setAttributeFloorExpanded(true)
        return
      }
      if(association.TYPE === undefined){
        alert.error("Veuillez sélectionner le type de l'association");
        setAttributeFloorExpanded(true)
        return
      }
      if(!association.POURCENTAGE){
        alert.error("Veuillez saisir un pourcentage");
        setAttributeFloorExpanded(true)
        return
      }
      if(!association.PRIX_VENTE){
        alert.error("Veuillez saisir le prix de vente de l'association");
        setAttributeFloorExpanded(true)
        return
      }
    }
    if(saveSample && !sampleName){
      alert.error("Veuillez saisir un nom");
      return
    }
    setDisableSubmit(true);
    addDivision(isMultipleBiens ? (biens || []).map(e => e.id) : [bienT.id], floors, !isMultipleBiens && withDoa && bienT?.contrat?.TYPE_VENTE === "UNIQUE" ? bienT.contrat.id : undefined, !isMultipleBiens && withDoa && bienT?.contrat?.TYPE_VENTE === "UNIQUE" ? association : undefined, selectedDivisionSample?.value?.id, saveSample ? 1 : 0, sampleName, withDoa ? 1 : 0, auth?.user?.id, callback);
  }

  return <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle} className="modal-dialog-extra-large">
    <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faLockOpen} />&nbsp;&nbsp;Répartition Association</ModalHeader>
    <ModalBody>
        <div className="linesConfirmationContainer">
          <Row className="mb-2">
            <Col xs="12">Répartition d'association {isMultipleBiens ? "des biens" : "du bien"}&nbsp;<b>{isMultipleBiens ? (biens || []).map(e => e.DESIGNATION || "").join(", ") : (bien?.DESIGNATION || "")}</b></Col>
          </Row>
          <Row>
            <Col xs="12">
              <Container className="CardInfo">
                <Row className="justify-content-center">
                  <h3>Ajout Étage</h3>
                </Row>
                <Row style={{padding: 0}}>
                  <Col xs="12" sm="4" style={{border: "none"}}>
                    <FormGroup>
                      <Label for="etage">Étage</Label>
                      <Select
                        id="etage"
                        name="etage"
                        className="reactselect"
                        classNamePrefix="react-select"
                        defaultValue={etageOptions?.length ? etageOptions[0] : ""}
                        value={floorValue}
                        onChange={handleEtageChange}
                        isClearable={false}
                        loadingMessage={() => 'Chargement...'}
                        noOptionsMessage={() => 'pas de resultat'}
                        isSearchable={false}
                        options={etageOptions}                
                      />
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="4" style={{border: "none"}}>
                    <FormGroup>
                      <Label for="types">Répartitions possibles</Label>
                      <Select
                        id="types"
                        className="reactselect"
                        classNamePrefix="react-select"
                        isMulti
                        value={partitionTypesValue?.map(e => ({label: e["name"], value: e})) || []}
                        onChange={handlePartitionTypesChange}
                        placeholder={'Chercher...'}
                        isClearable={true}
                        isLoading={loadingT}
                        loadingMessage={() => 'Chargement...'}
                        noOptionsMessage={() => 'pas de resultat'}
                        isSearchable={true}
                        labelKey='name'
                        options={partitionTypeOptions}
                        menuContainerStyle={{ zIndex: 9999999 }} />
                      {/* <Select
                        id="type"
                        className="reactselect"
                        classNamePrefix="react-select"
                        value={partitionTypeValue ? {label: partitionTypeValue.label, value: partitionTypeValue} : null}
                        onChange={typeChangeHandler}
                        formatCreateLabel={(e, t) => `${e}`}
                        placeholder={'Type...'}
                        isClearable={true}
                        loadingMessage={() => 'Chargement...'}
                        noOptionsMessage={() => 'pas de resultat'}
                        isSearchable={true}
                        options={partitionTypeOptions}
                        menuContainerStyle={{ zIndex: 9999999 }}
                      /> */}
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="4" style={{border: "none"}}>
                    <FormGroup>
                      <Label for="prixpart">Prix étage</Label>
                      <InputGroup className="quantityInputGroup">
                        {/* <Input id="prixpart" type="number" pattern="[0-9]*" placeholder="Prix part..." innerRef={prixpartRef} value={Number(prixpartValue).toString()} onFocus={focusHandler} onChange={prixpartChangeHandler} className="form-control" /> */}
                        <NumberFormat customInput={Input} thousandSeparator={' '} allowNegative={false} id="prixpart" pattern="[0-9]*" placeholder="Prix part..." innerRef={totalPriceRef} value={totalPriceValue} defaultValue={0} decimalScale={2} onFocus={focusHandler} onValueChange={e => setTotalPriceValue(e.value ? +e.value : 0)}/* onChange={prixpartChangeHandler}*/ onKeyDown={e => (e.key === 'Enter' && addFloorHandle())} className="form-control" />
                        <InputGroupAddon addonType="append">
                          <InputGroupText>DH</InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="justify-content-center" style={{padding: 0}}>
                  <Button
                    className="btn btn-info linesConfirmationBtn"
                    onClick={addFloorHandle}
                    ><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Ajouter</Button>
                </Row>
              </Container>
            </Col>
          </Row>
          <div className="moreSettings" style={{padding: 0, fontSize: "small"}}>
            <p onClick={() => setLoadSampleExpanded(e => !e)} style={{marginBottom: "5px"}}><FontAwesomeIcon icon={faAngleDoubleDown} className={`flipIcon${loadSampleExpanded ? " flipped" : ""}`} />&nbsp;&nbsp;Charger un groupe</p>
          </div>
          <Collapse className="mb-2" isOpen={loadSampleExpanded}>
            <Row className="justify-content-center">
              <Col xs="10" style={{border: "none"}}>
                <FormGroup>
                  <Label for="sample">Groupe</Label>
                  <Select
                    id="sample"
                    className="reactselect"
                    classNamePrefix="react-select"
                    value={selectedDivisionSample ? {label: selectedDivisionSample.label, value: selectedDivisionSample} : null}
                    onChange={handleDivisionSampleChange}
                    formatCreateLabel={(e, t) => `${e}`}
                    placeholder={'Groupe...'}
                    isClearable={true}
                    loadingMessage={() => 'Chargement...'}
                    noOptionsMessage={() => 'pas de resultat'}
                    isSearchable={true}
                    options={divisionsampleOptions}
                    menuContainerStyle={{ zIndex: 9999999 }}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Collapse>
          {!!((!isMultipleBiens && bien) || (isMultipleBiens && biens?.length)) && <Row>
            <Col xs="12">
              <Association etages={(isMultipleBiens ? biens?.reduce((e, t) => e && Number(t.PRIX_VENTE || 0) > Number(e.PRIX_VENTE || 0) ? t : e, {} as any) : bien)?.ETAGE_ASS} division={{bienId: (isMultipleBiens ? biens?.reduce((e, t) => e && Number(t.PRIX_VENTE || 0) > Number(e.PRIX_VENTE || 0) ? t : e, {} as any) : bien)?.id || -1, division_floors: floors}} isDraft removeFloor={index => {setSelectedDivisionSample(''); setFloors(e => e.filter(t => t.index !== index))}} />
            </Col>
          </Row>}
          {!isMultipleBiens && bien?.contrat?.TYPE_VENTE === "UNIQUE" && <>
            <div className="divisionCollapseOpener" onClick={() => setAttributeFloorExpanded(e => !e)}>
                <div style={{fontFamily: "'Ultra', sans-serif", fontStyle: "italic", letterSpacing: "2px"}}><FontAwesomeIcon icon={faEdit} />&nbsp;Sélectionnez l'étage où mettre la réservation actuelle</div>
                <FontAwesomeIcon icon={faAngleDown} className={`flipIcon${attributeFloorExpanded ? " flipped" : ""}`} />
              </div>
            <Collapse className="mb-2" isOpen={attributeFloorExpanded}>
              <Row className="mt-4">
                <Col xs="12">
                  <AssociationFields isDoa={true} selectedBien={{...(bien || {}), division: {bienId: bien?.id, division_floors: floors}}} selectedFloor={selectedFloor} setSelectedFloor={setSelectedFloor} selectedDivisionType={selectedDivisionType} setSelectedDivisionType={setSelectedDivisionType} selectedDivisionPercent={selectedDivisionPercent} setSelectedDivisionPercent={setSelectedDivisionPercent} etageValue={etageValue} setEtageValue={setEtageValue} typeValue={typeValue} setTypeValue={setTypeValue} positionValue={positionValue} setPositionValue={setPositionValue} percentValue={percentValue} setPercentValue={setPercentValue} superficieValue={superficieValue} setSuperficieValue={setSuperficieValue} prixpartValue={prixpartValue} setPrixpartValue={setPrixpartValue} commentValue={partCommentValue} setCommentValue={setPartCommentValue} />
                </Col>
              </Row>
            </Collapse>
          </>}
          {!!auth?.user?.privileges?.includes(PRIVILEGE.APPROVE_DIVISION) && !selectedDivisionSample?.value && <div className="fullFlexCenter">
            <CustomInput type="switch" id="saveSample" name="saveSampleSwitch" label="Enregistrer un nouveau groupe" checked={saveSample} onChange={e => setSaveSample(e.target.checked)} />
          </div>}
          {!!saveSample && <Row className="justify-content-center">
            <Col xs="12" sm="4" style={{border: "none"}}>
              <Input id="sampleName" type="text" placeholder="Nom du Groupe..." value={sampleName} onChange={sampleNameChangeHandler} className="form-control" />
            </Col>
          </Row>}
          <Row className="justify-content-center">
            <Col xs="12" md="4">
              <Button
                // className="btn btn-success linesConfirmationBtn linesDeleteBtn"
                className="btn btn-info linesConfirmationBtn"
                onClick={() => addDivisionHandle(false)}
                disabled={disableSubmit || true}
                ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Valider la répartition</Button>
            </Col>
            <Col xs="12" md="6">
              <Button
                className="btn btn-success linesConfirmationBtn"
                onClick={() => addDivisionHandle(true)}
                disabled={disableSubmit}
                ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faLockOpen} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Valider la répartition et ouvrir en association</Button>
            </Col>
          </Row>
          {floors.reduce((e, t) => e + Number(t.totalPrice || 0), 0) < Number((isMultipleBiens ? biens?.reduce((e, t) => e && Number(t.PRIX_VENTE || 0) > Number(e.PRIX_VENTE || 0) ? t : e, {} as any) : bien)?.PRIX_VENTE || 0) && <div className="divisionRemainingAmountText">
            Il vous reste {(Number((isMultipleBiens ? biens?.reduce((e, t) => e && Number(t.PRIX_VENTE || 0) > Number(e.PRIX_VENTE || 0) ? t : e, {} as any) : bien)?.PRIX_VENTE || 0) - floors.reduce((e, t) => e + Number(t.totalPrice || 0), 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH à répartir
          </div>}
        </div>
    </ModalBody>
  </Modal>
};

const mapStateToProps = (state: IDivisionModalReduxProps) => ({
  auth: state.auth,
  error: state.error,
  division_sample: state.division_sample,
  division_partition_type: state.division_partition_type,
});

export default connect(mapStateToProps, { addDivision, getDivisionSamples, clearDivisionSamples, getDivisionPartitionTypes, clearDivisionPartitionTypes })(DivisionModal);
